@if (documents().length > 0) {
  <p-listbox
    [options]="documents()"
    [(ngModel)]="selection"
    optionLabel="name"
    dataKey="documentId"
    [multiple]="true"
    [checkbox]="true"
    [filter]="true"
    [filterBy]="'name'"
    [filterPlaceHolder]="'ASSISTANCE_ATTACHMENTS.DOCUMENT_PICKER.SEARCH_PLACEHOLDER' | transloco"
    [autoOptionFocus]="false"
    [focusOnHover]="false"
    [metaKeySelection]="false"
    styleClass="w-full"
    [listStyle]="{ 'max-height': '300px' }"
  ></p-listbox>

  <div class="ion-text-end ion-margin-top">
    <button
      pButton
      type="button"
      icon="pi pi-paperclip"
      [label]="'ASSISTANCE_ATTACHMENTS.DOCUMENT_PICKER.ATTACH_SELECTED' | transloco"
      class="p-button-sm"
      [disabled]="selection.length === 0"
      (click)="confirm()"
    ></button>
  </div>
} @else {
  <p>{{ 'ASSISTANCE_ATTACHMENTS.DOCUMENT_PICKER.NO_DOCUMENTS' | transloco }}</p>
}
